import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ActiveChallenges = ({ limit, showAll = false }) => {
  const [challenges, setChallenges] = useState([]);

  useEffect(() => {
    fetchChallenges();
  }, []);

  const fetchChallenges = async () => {
    // Mock data - replace with actual Supabase queries
    const mockChallenges = [
      {
        id: 1,
        name: 'January Fitness Challenge',
        description: 'Complete 20 workouts in January',
        type: 'individual',
        icon: 'Target',
        startDate: '2026-01-01',
        endDate: '2026-01-31',
        progress: 65,
        currentValue: 13,
        targetValue: 20,
        reward: 500,
        participants: 247,
        isJoined: true
      },
      {
        id: 2,
        name: 'Team Cardio Blast',
        description: 'Team challenge: Burn 50,000 calories together',
        type: 'team',
        icon: 'Users',
        startDate: '2026-01-15',
        endDate: '2026-01-29',
        progress: 42,
        currentValue: 21000,
        targetValue: 50000,
        reward: 750,
        participants: 48,
        teamName: 'Cardio Warriors',
        isJoined: true
      },
      {
        id: 3,
        name: 'Early Bird Special',
        description: 'Check in before 7 AM for 10 days',
        type: 'individual',
        icon: 'Sunrise',
        startDate: '2026-01-20',
        endDate: '2026-02-05',
        progress: 30,
        currentValue: 3,
        targetValue: 10,
        reward: 300,
        participants: 89,
        isJoined: false
      }
    ];
    setChallenges(mockChallenges);
  };

  const handleJoinChallenge = async (challengeId) => {
    // Implement join challenge logic
    alert('Joined challenge successfully!');
  };

  const displayedChallenges = showAll ? challenges : challenges?.slice(0, limit || 3);

  const getDaysRemaining = (endDate) => {
    const end = new Date(endDate);
    const now = new Date();
    const diff = Math.ceil((end - now) / (1000 * 60 * 60 * 24));
    return diff;
  };

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-xl font-heading font-semibold text-foreground mb-1">
            Active Challenges
          </h2>
          <p className="text-sm text-muted-foreground">
            Join challenges to earn bonus points and compete with others
          </p>
        </div>
      </div>

      <div className="space-y-4">
        {displayedChallenges?.map((challenge) => {
          const daysRemaining = getDaysRemaining(challenge?.endDate);
          
          return (
            <div
              key={challenge?.id}
              className={`p-5 rounded-lg border-2 transition-all duration-250 ${
                challenge?.isJoined
                  ? 'border-primary/30 bg-primary/5' :'border-border hover:border-border/60'
              }`}
            >
              <div className="flex flex-col md:flex-row gap-4">
                <div className="flex-1">
                  <div className="flex items-start gap-3 mb-3">
                    <div
                      className={`w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0 ${
                        challenge?.isJoined ? 'bg-primary/20' : 'bg-muted'
                      }`}
                    >
                      <Icon
                        name={challenge?.icon}
                        size={24}
                        color={challenge?.isJoined ? 'var(--color-primary)' : 'var(--color-muted-foreground)'}
                      />
                    </div>
                    <div className="flex-1">
                      <div className="flex items-start justify-between gap-2 mb-1">
                        <h3 className="font-semibold text-foreground">
                          {challenge?.name}
                        </h3>
                        <span
                          className={`px-2 py-1 rounded-full text-xs font-medium flex-shrink-0 ${
                            challenge?.type === 'team' ?'bg-accent/20 text-accent' :'bg-primary/20 text-primary'
                          }`}
                        >
                          {challenge?.type === 'team' ? 'Team' : 'Individual'}
                        </span>
                      </div>
                      <p className="text-sm text-muted-foreground mb-2">
                        {challenge?.description}
                      </p>
                      {challenge?.teamName && (
                        <div className="flex items-center gap-1 mb-2">
                          <Icon name="Users" size={14} color="var(--color-accent)" />
                          <span className="text-xs text-accent font-medium">
                            {challenge?.teamName}
                          </span>
                        </div>
                      )}
                      <div className="flex items-center gap-4 text-xs text-muted-foreground">
                        <div className="flex items-center gap-1">
                          <Icon name="Users" size={14} />
                          <span>{challenge?.participants} participants</span>
                        </div>
                        <div className="flex items-center gap-1">
                          <Icon name="Clock" size={14} />
                          <span>{daysRemaining} days left</span>
                        </div>
                        <div className="flex items-center gap-1">
                          <Icon name="Coins" size={14} color="var(--color-primary)" />
                          <span className="text-primary font-medium">+{challenge?.reward} pts</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  {challenge?.isJoined && (
                    <div className="mt-4">
                      <div className="flex justify-between text-sm mb-2">
                        <span className="text-muted-foreground">Your Progress</span>
                        <span className="font-medium text-foreground">
                          {challenge?.currentValue?.toLocaleString()} / {challenge?.targetValue?.toLocaleString()}
                        </span>
                      </div>
                      <div className="h-2 bg-muted rounded-full overflow-hidden">
                        <div
                          className="h-full bg-gradient-to-r from-primary to-accent transition-all duration-500"
                          style={{ width: `${challenge?.progress}%` }}
                        ></div>
                      </div>
                      <p className="text-xs text-muted-foreground mt-1">
                        {challenge?.progress}% complete
                      </p>
                    </div>
                  )}
                </div>

                {!challenge?.isJoined && (
                  <div className="flex items-center">
                    <Button
                      variant="default"
                      onClick={() => handleJoinChallenge(challenge?.id)}
                    >
                      Join Challenge
                    </Button>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>

      {!showAll && challenges?.length > (limit || 3) && (
        <div className="mt-4 text-center">
          <Button variant="outline" iconName="ChevronRight">
            View All Challenges
          </Button>
        </div>
      )}
    </div>
  );
};

export default ActiveChallenges;